import { generateDOB, getGenderTitle } from '../../officer/payloadUtils/mapOfiicerDetails';
import { OTHER_KEY } from '../../../utils/constants';
import { CountryUtil } from '../../../components/utils/countryUtils';

export const createPrimaryApplicant = data => {
  if (data && data.personal_details) {
    const applicant = {
      firstName: data.personal_details.name.first_name,
      middleName: data.personal_details.name.middle_name
        ? data.personal_details.name.middle_name
        : '',
      lastName: data.personal_details.name.last_name,
      dob: generateDOB(data.personal_details.dob),
      nationality: CountryUtil.getValueForPrimaryCustNationality(data.personal_details.nationality),
      country_of_residence: CountryUtil.getValueForCountryName(
        data.personal_details.country_of_residence
      ),
      isPrimary: true
    };
    return Object.assign({}, applicant, getGenderTitle(data.personal_details.name.title));
  }
  return {};
};

export const getNationalityInfo = data => {
  if (data && data.personal_details) {
    return {
      nationality: CountryUtil.getValueForPrimaryCustNationality(data.personal_details.nationality),
      country_of_residence: CountryUtil.getValueForCountryName(
        data.personal_details.country_of_residence
      )
    };
  }
};

export const getSwitchAccountInfo = data => {
  const SLICE_FOUR = 4;
  const SLICE_SIX = 6;
  if (data && data.business_details && data.business_details.switch_account) {
    const sort_code = data.business_details.switch_account.sort_code || '';
    return {
      oldSortCode: {
        sortField1: sort_code.slice(0, 2),
        sortField2: sort_code.slice(2, SLICE_FOUR),
        sortField3: sort_code.slice(SLICE_FOUR, SLICE_SIX)
      },
      account_number: data.business_details.switch_account.account_number || ''
    };
  }
};

export const getNationality = signatory =>
  signatory && signatory.nationality === OTHER_KEY
    ? signatory.nationalityOther
    : signatory.nationality;

export const getCountryOfResidence = signatory =>
  signatory && signatory.country_of_residence === OTHER_KEY
    ? signatory.countryOther
    : signatory.country_of_residence;
